/*
* 类型判断
* 用途：判断数据类型
* 用法：vue.$typejudge
* 方法：
*     isArray
*     isJson
* */

class typejudge {
  isArray (obj) { // 判断是不是数组
    return toString.call(obj) === '[object Array]';
  };
  isJson (obj) { // 判断是不是json对象
    return toString.call(obj) === '[object Object]';
  };
}

export default new typejudge();



// WEBPACK FOOTER //
// ./src/utils/typejudge.js